import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../../config/config";

// Every place a tenant or an owner can stall between sign-up and a running
// tenancy, so the team can follow up wherever someone is stuck (not just the
// OTS-fee step, which has its own detailed screen — see OtsFeeReceipts).
const authHeaders = () => {
  const token =
    sessionStorage.getItem("ots_token") || localStorage.getItem("ots_token");
  return { Authorization: `Bearer ${token}` };
};

const messageOf = (error, fallback) =>
  error.response?.data?.message || error.message || fallback;

export const GetTenantFunnel = createAsyncThunk(
  "tenantFunnel/list",
  async ({ stage = "all" } = {}, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${BASE_URL}/admin/tenant-funnel`, {
        params: { stage },
        headers: authHeaders(),
      });
      return res.data;
    } catch (error) {
      return rejectWithValue({
        message: messageOf(error, "Failed to load the tenant funnel"),
      });
    }
  }
);

const TenantFunnelSlice = createSlice({
  name: "tenantFunnel",
  initialState: {
    loading: false,
    data: {
      registered_only: [],
      awaiting_payment: [],
      paid_cash: [],
      paid_online: [],
      owner_pending_requests: [],
      owner_payment_unverified: [],
      move_in_overdue: [],
      move_out_requests: [],
    },
    counts: {
      registered_only: 0,
      awaiting_payment: 0,
      paid_cash: 0,
      paid_online: 0,
      owner_pending_requests: 0,
      owner_payment_unverified: 0,
      move_in_overdue: 0,
      move_out_requests: 0,
    },
    // Which stages THIS admin may see — narrower than the full 8 for anyone
    // holding one of the split permissions instead of the full verify_payments.
    allowedStages: null,
    error: "",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetTenantFunnel.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(GetTenantFunnel.fulfilled, (state, action) => {
        state.loading = false;
        state.data = { ...state.data, ...(action.payload?.data || {}) };
        state.counts = { ...state.counts, ...(action.payload?.counts || {}) };
        if (action.payload?.allowedStages) {
          state.allowedStages = action.payload.allowedStages;
        }
      })
      .addCase(GetTenantFunnel.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to load the tenant funnel";
      });
  },
});

export default TenantFunnelSlice.reducer;
